<template>
  <el-alert
    v-if="model.error"
    effect="light"
    class="alert-container"
    :title="errorTitle"
    :type="errorType"
    :closable="false"
    :show-icon="true"
  ></el-alert>
</template>

<script>
import { PushActionErrorLabel } from '@/common/enum/PushActionErrorEnum'

export default {
  name: 'NotificationError',

  props: {
    model: {
      required: true
    }
  },

  computed: {
    errorType() {
      return this.model.sent_count ? 'warning' : 'error'
    },

    errorTitle() {
      let message = this.model.error_message
      if (message.includes('tls: expired certificate')) {
        message = 'expiredCertificate'
      }
      return message in PushActionErrorLabel
        ? this.$t(PushActionErrorLabel[message])
        : message
    }
  }
}
</script>

<style scoped>
.alert-container {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/modules/notifications-log/components/NotificationError.vue